<template>
  <div class="aboutUs">
    <div class="about-content" v-if="!isLook">
      <div class="top-header">
        <span class="line"></span>
        <div class="title">
          <div>平台公告</div>
          <el-input v-model="searchKey" style="width: 300px" placeholder="请输入你需要搜索的内容" @keyup.enter.native="searchEnter" suffix-icon="el-icon-search"/>
        </div>
        <div class="bd-y"></div>
      </div>
      <div class="news-content">
        <div v-for="(item, index) in showList" :key="index" class="newsItem" @click="newsDetailClick(item)">
          <div style="display: flex;align-items: center;">
            <div class="title-left-tag" v-if="item.topEnable">置顶</div>
            <el-tooltip class="item" :open-delay="1000" effect="dark" placement="top">
              <div class="news">
              {{item.title}}
              </div>
              <div slot="content" style="max-width:300px">{{item.title}}</div>
            </el-tooltip>
          </div>
          <div class="time">{{item.time}}</div>
        </div>
      </div>
      <div class="foot-page">
        <div class="page-font">共{{page.total}}项数据</div>
        <el-pagination background layout="prev, pager, next" :current-page="page.current" :total="page.total"
         @current-change="currentChange" @prev-click="currentChange" @next-click="currentChange"></el-pagination>
      </div>
    </div>
    <div class="news-detail" v-else>
      <div class="detail-title">
        <div class="back-btn" @click="back"><i class="el-icon-back"></i></div>
        <div class="title-mide">
          <div style="margin-bottom: 5px"><span class="title">{{info.title}}</span></div>
          <div><span class="time">{{info.time}}</span></div>
        </div>
      </div>
      <div class="content">
        <p v-html="info.content"></p>
      </div>
    </div>
  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@/constants'
export default {
  data() {
    return {
      searchKey: '',
      newList: [],
      showList: [],
      isLook: false,
      page: { total: 0, current: 1, size: 10 },
      info: {},
      empty: false
    }
  },
  mounted() {
    // this.page.total = this.newList.length
    this.searchFun()
    // this.showList = this.newList.slice(0, 10)
  },
  methods: {
    searchEnter() {
      this.searchFun(1)
    },
    back() {
      this.isLook = false
    },
    currentChange(val) {
      this.page.current = val
      this.searchFun()
    },
    /**
     * @description  点击新闻进入
     */
    newsDetailClick(item) {
      // 打开新闻详情页
      let params = { id: item.id }
      this.$API.noticeDetail(params).then(res => {
        if(res.code === RESPONSE_SUCCESS) {
          // 赋值页码
          const {noticeContent, publishTime, title} = res.data
          this.isLook = true
          this.info = {
            title,
            time: publishTime ? publishTime.split(' ')[0] : '',
            content: noticeContent
          }
        } else {
          this.$message.error(`获取新闻详情失败,${res.msg}`)
        }
      })
    },
    /**
     * @description  点击关键字搜索
     */
    searchFun(current){
      // 传入参数有current
      if (current) {
        this.page.current = 1
      }
      // 点击搜索
      let params = {
        current: this.page.current,
        size: this.page.size,
        title: this.searchKey
      }
      this.$API.noticePage(params).then(res => {
        if(res.code === RESPONSE_SUCCESS) {
          const {data} = res
          // 赋值页码
          this.page.current = data.current || 1
          this.page.size = data.size || 10
          this.page.total = data.total || 0
          // 时间不要时分秒，可以通过截取的操作
          if(data.records && data.records.length > 0) {
            data.records.forEach((item,index,array) => {
              array[index].time = item ? item.publishTime.split(' ')[0] : ''
            });
          }
          this.showList = data.records || []
          // this.showList = this.newList.slice((this.page.current -1) * 10, this.page.current * 10)
          this.empty =  this.showList.length>0 ? false : true
          if(this.empty) {
            this.searchKey.length>0? this.$message.warning('没有找到相关公告') : this.$message.warning('暂无公告')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.aboutUs {
  padding-top: 64px;
  padding-bottom: 20px;
    background: #f4f5f7;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    .about-content, .news-detail {
      width: 1200px;
      background-color: #fff;
      margin: 0 auto;
      height: calc(100vh - 104px);
      margin-top: 20px;
      border-radius: 6px;
      position: relative;
    }
    .about-content {
      .top-header {
        .title {
          font-size: 26px;
          font-weight: 600;
          padding: 15px 10px 15px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          ::v-deep .el-input__inner {
            border-radius: 6px;
          }
          ::v-deep .el-input__inner:hover {
            border-color: #E60000;
            box-shadow: 0 0 5px #E60000;
          }
        }
        .line {
          width: 4px;
          height: 28px;
          background: $theme-color;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 22px;
        }
        .bd-y {
          height: 1px;
          background-color: #D9D9D9;
        }
      }
      .news-content {
        padding: 20px 40px;
        height: calc(100vh - 296px);
        overflow: auto;
        .newsItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 55px;
          line-height: 55px;
          border-bottom: 1px solid #eee;
          .title-left-tag {
            width: 31px;
            height: 18px;
            border: 1px solid #E60000;
            font-size: 12px;
            line-height: 18px;
            color: #E60000;
            font-weight: bold;
            text-align: center;
            border-radius: 3px;
          }
          .news {
            font-size: 16px;
            font-weight: 500;
            width: 800px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 10px;
          }
          .time {
            font-size: 14px;
            font-weight: 500;
            color: #A4A4A4;
            width: 100px;
          }
          &:hover {
            .time {
              color: #e60000 !important;
            }
            color: #e60000 !important;
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
      .foot-page {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 50px 40px 20px;
        position: absolute;
        bottom: 10px;
        width: 1100px;
        .page-font {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: rgba(0,0,0,0.60);
        }
      }
    }
    .news-detail {
      .detail-title {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #D9D9D9;
        height: 80px;
        .back-btn{
          font-size: 20px;
          margin-left: 50px;
        }
        .back-btn:hover {
          color:#E60000;
          cursor: pointer;
        }
        .title-mide {
          width: 1090px;
          text-align: center;
          .title {
            font-size: 16px;
            font-weight: 800;
          }
          .time {
            color: #9499a3;
            font-size: 14px;
          }
        }
      }
      .content {
        padding: 20px;
        p {
          text-indent: 24px;
          color: '#61666d';
          font-size: 14px;
          font-weight: 400;
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }
</style>
